import Ntt from './Ntt'

export default Ntt
